/* eslint-disable quotes */
type TypeOfBed = 'CALIFORNIA_KING' | 'KING' | 'QUEEN' | 'FULL' | 'DOUBLE' | 'SEMI_DOUBLE' | 'SINGLE'

export const getJsonLdSuitesGrid = ({ data, lang }) => {
  const obj = {
    "@context": "https://schema.org",
    "@type": ["Hotel", "ItemList"],
    "name": "Portella Palma",
    "description": "Explore our luxurious suites designed for ultimate comfort and elegance.",
    "url": `https://portellapalma.com/${lang}/suites`,
    "image": "https://portellapalma.com/images/1.jpeg",
    "telephone": "+34-871-62-62-63",
    "priceRange": "€€",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "Calle de la Portella, 9",
      "addressLocality": "Palma de Mallorca",
      "addressRegion": "Illes Balears",
      "postalCode": "07001",
      "addressCountry": "ES"
    },
    "itemListElement": data.map((item, idx) => (
      {
        "@type": "ListItem",
        "position": idx + 1,
        "item": {
          "@type": ["HotelRoom", "Product"],
          "identifier": `hotel-room-type-${item.roomType}-${item.id}`,
          "name": item.plpTitle,
          "description": item.plpDescription,
          ...item.medium?.image?.l?.src && { "image": item.medium.image.l.src },
          "url": `https://portellapalma.com/${lang}/suite/${item.slug}`,
          "offers": {
            "@type": ["Offer", "LodgingReservation"],
            "price": 1500,
            "priceValidUntil": "2025-12-31",
            "priceCurrency": "EUR",
            "availability": "https://schema.org/InStock",
          },
          "aggregateRating": {
            "@type": "AggregateRating",
            "bestRating": "5",
            "ratingValue": "5",
            "reviewCount": "18"
          },
          "bed": {
            "@type": "BedDetails",
            "numberOfBeds": ['double', 'doble'].includes(item.plpTitle) ? 2 : 1,
            "typeOfBed": "KING" as TypeOfBed,
          },
          "occupancy": {
            "@type": "QuantitativeValue",
            "value": ['apart', 'arab'].includes(item.plpTitle) ? 4 : 2
          },
          "amenityFeature": [
            {
              "@type": "LocationFeatureSpecification",
              "name": "AC",
              "value": true
            },
            {
              "@type": "LocationFeatureSpecification",
              "name": "Wifi",
              "value": true
            },
            {
              "@type": "LocationFeatureSpecification",
              "name": "Minibar",
              "value": true
            },
            {
              "@type": "LocationFeatureSpecification",
              "name": "InternetType",
              "value": "FREE"
            },
            ...(['apart', 'arab'].includes(item.plpTitle) ? [{
              "@type": "LocationFeatureSpecification",
              "name": "Kitchen",
              "value": true
            }]: [])
          ]
        },
      }
    ))
  }

  return JSON.stringify(obj)
}
